import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useMutation } = ReactQueryV5;
import { post } from "../services/httpClient";

type TreatmentStatusPayload = {
  patientUserId: number;
  type: string;
  endTreatmentReason?: string;
};

const postTreatmentStatus = (data: TreatmentStatusPayload) =>
  post<unknown, TreatmentStatusPayload>("treatment-event", data);

export const usePostTreatmentStatus = () =>
  useMutation({
    mutationFn: postTreatmentStatus,
  });
